<script setup lang="ts">
import TheIngredientExclusions from '@/components/Menus/Filters/TheIngredientExclusions.vue';
import TheMenuAllergens from '@/components/Menus/Filters/TheMenuAllergens.vue';
import TheMenuDietType from '@/components/Menus/Filters/TheMenuDietType.vue';
import TheMenuNutrients from '@/components/Menus/Filters/TheMenuNutrients.vue';
// import { type MessageSchema } from '@/i18n';
// import { useDishesStore } from '@/stores/dishesStore';
// import { ref } from 'vue';
// import { useI18n } from 'vue-i18n';

// const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

// const dishesStore = ref(useDishesStore());
</script>

<template>
  <TheMenuDietType />
  <TheIngredientExclusions />
  <TheMenuAllergens />
  <TheMenuNutrients />
</template>
